import { Action } from '@interstate/components/Action';
import { LockOpenIcon, LockClosedIcon } from '@interstate/components/Icons';

import { useLockDeal } from './useLockDeal';

export function LockDealButton() {
    const { isLockSupported, isLocked, isDisabled, toggleLock } = useLockDeal();

    if (!isLockSupported) return null;

    return (
        <Action
            actionIcon={{
                icon: isLocked ? (
                    <LockClosedIcon title="Toggle unlock for Term, APR and Credit Tier" />
                ) : (
                    <LockOpenIcon title="Toggle lock for Term, APR and Credit Tier" />
                ),
                start: true
            }}
            id="lock-sv-terms-button"
            data-testid="lock-sv-terms-button"
            onClick={toggleLock}
            size="lg"
            disabled={isDisabled}
        />
    );
}
